import { useState, useEffect } from 'react';
import {
  clearTokens,
  getAccessToken,
  getCurrentUser,
  getRefreshToken,
  refreshAccessToken,
  setAccessToken
} from '../lib/walterhouseApi';

export const useWalterHouseUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const syncUser = async () => {
      try {
        const accessToken = getAccessToken();
        const refreshToken = getRefreshToken();

        if (!accessToken && !refreshToken) {
          if (isMounted) {
            setUser(null);
            setLoading(false);
          }
          return;
        }

        if (accessToken) {
          const profile = await getCurrentUser(accessToken);
          if (isMounted) {
            setUser(profile);
            setLoading(false);
          }
          return;
        }

        const refreshed = await refreshAccessToken(refreshToken);
        if (refreshed?.accessToken) {
          setAccessToken(refreshed.accessToken);
          const profile = await getCurrentUser(refreshed.accessToken);
          if (isMounted) {
            setUser(profile);
          }
        } else if (isMounted) {
          setUser(null);
        }
      } catch (error) {
        clearTokens();
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    const handleStorage = (event) => {
      if (event.key === 'wh_access_token' || event.key === 'wh_refresh_token') {
        setLoading(true);
        syncUser();
      }
    };

    syncUser();
    window.addEventListener('storage', handleStorage);

    return () => {
      isMounted = false;
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return { user, loading };
};
